module.exports = __webpack_public_path__ + "img/timeback.56a1a7f4.svg";